import React, { useEffect, useState } from 'react';
import { subscribe } from '../services/newsletter';
import SignupChallenge from './SignupChallenge';

export default function Newsletter({ gym = false }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');
  const [config, setConfig] = useState(null);
  const [token, setToken] = useState('');
  const [website, setWebsite] = useState('');
  const [challengeAttempt, setChallengeAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    fetch(gym ? '/api/gym/newsletter/config' : '/api/newsletter/config', { signal: controller.signal })
      .then(response => { if (!response.ok) throw new Error(); return response.json(); })
      .then(value => { if (!controller.signal.aborted) { setConfig(value); if (!value.enabled) setMessage('Signup is temporarily unavailable. Please check back soon.'); } })
      .catch(() => { if (!controller.signal.aborted) setMessage('Signup is temporarily unavailable. Please check back soon.'); });
    return () => controller.abort();
  }, [gym]);
  async function submit(event) {
    event.preventDefault();
    if (status === 'pending') return;
    if (!config?.enabled || (config.turnstileSiteKey && !token)) { setMessage('Please complete the spam-protection check.'); return; }
    setStatus('pending'); setMessage('');
    try {
      await subscribe(email, token, website, gym); setStatus('success');
      setMessage('Check your inbox to confirm your signup. You’ll only receive updates after confirming.'); setEmail('');
    } catch (error) {
      setStatus('error');
      setMessage(error.name === 'TimeoutError' ? 'The connection timed out. Please try again.' : error.message);
    } finally {
      setToken(''); setChallengeAttempt(attempt => attempt + 1);
    }
  }
  return <section id="updates" className="newsletter" aria-labelledby="newsletter-heading">
    <div><p className="eyebrow">{gym ? 'THE FIRST CHAPTER' : 'THE NEXT ROUND'}</p><h2 id="newsletter-heading">{gym ? 'Your gym. Your first look.' : 'Stay in the loop.'}</h2>
      <p>{gym ? 'Opening news, a look inside the build, class announcements, and founding-member details. Follow the journey from the beginning.' : <>New gear, product updates, and Hikari discounts.<br />Straight to your inbox.</>}</p></div>
    <form onSubmit={submit}>
      <label htmlFor="email">Your email address</label>
      <div className="email-row">
        <input id="email" type="email" name="email" autoComplete="email" maxLength="254" required placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} disabled={status === 'pending'} aria-describedby="signup-consent signup-status" />
        <button type="submit" disabled={status === 'pending' || !config?.enabled || (config.turnstileSiteKey && !token)}>{status === 'pending' ? 'Joining…' : 'Count me in'} <span aria-hidden="true">↗</span></button>
      </div>
      <div className="signup-honeypot" aria-hidden="true"><label htmlFor="signup-website">Leave this field empty</label><input id="signup-website" name="website" type="text" tabIndex={-1} autoComplete="off" value={website} onChange={event => setWebsite(event.target.value)} /></div>
      {config?.enabled && config.turnstileSiteKey && <SignupChallenge key={challengeAttempt} siteKey={config.turnstileSiteKey} onToken={setToken} onError={setMessage} />}
      <p id="signup-consent" className="consent">{gym ? 'By signing up, you agree to receive Hikari gym news and founding-membership updates.' : 'Sign up for Hikari product news and offers.'} Confirm by email, and unsubscribe anytime using the link in each newsletter. Brevo manages your subscription.</p>
      <p id="signup-status" className="form-status" role="status" aria-live="polite">{message}</p>
    </form>
  </section>;
}
